'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _canUseDOM = require('./canUseDOM');

var _canUseDOM2 = _interopRequireDefault(_canUseDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var root = _canUseDOM2.default && document.documentElement;

  if (root && root.contains) {
    return function (context, node) {
      return context.contains(node);
    };
  } else if (root && root.compareDocumentPosition) {
    return function (context, node) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    };
  } else {
    return function (context, node) {
      if (node) {
        do {
          if (node === context) {
            return true;
          }
        } while (node = node.parentNode);
      }
      return false;
    };
  }
}();